import { isPhoneInLandscape } from '../../../../styles'
import type { Tokens } from '../../../../theming/types'

export default (config: { tokens: Tokens }) => {
  const { tokens } = config
  return {
    default: {
      wrap: {
        paddingBlockEnd: tokens.spacingGap400,
        paddingBlockStart: tokens.spacingGap300,
        paddingInline: tokens.spacingGap400,

        [isPhoneInLandscape]: {
          paddingBlock: tokens.spacingGap200,
          paddingInline: tokens.spacingGap200,
        },
      },
    },

    children: {
      wrap: {
        [isPhoneInLandscape]: {
          display: 'flex',
          flexDirection: 'column',
        },

        '& > button': {
          '&:first-of-type': {
            marginInlineEnd: tokens.spacingGap200,

            [isPhoneInLandscape]: {
              marginInlineEnd: 0,
            },
          },
        },
      },
    },
  } as const
}
